const base = {
  borderWidth: '1px',
  borderStyle: 'solid'
};

const alertBannerButton = {
  alert: {
    ...base,
    borderColor: 'red.50'
  },
  notice: {
    ...base,
    borderColor: 'green.20'
  },
  warning: {
    ...base,
    borderColor: 'yellow.10'
  },
  white: {
    ...base,
    borderColor: 'white'
  },
  announcement: {
    ...base,
    borderColor: 'blue.60',
    color: 'white'
  }
};

export default alertBannerButton;
